import { get } from 'lodash';

export const isServer = () => Boolean(get(process, 'release.name'));
